import React from 'react';
import { Icon, IconType } from '@chargify/icons';
import { BodyText, Box } from '../../../atoms';
import { TitleWrapper } from './Title.styles';

type Props = {
  text: string;
  icon?: IconType;
};
export const Title = ({ text, icon }: Props) => {
  return (
    <Box marginBottom={2}>
      <TitleWrapper gridGap={2}>
        {icon && <Icon type={icon} fill="currentColor" size={16} />}
        <BodyText variant="body2" color="inherit" fontWeight={700}>
          {text}
        </BodyText>
      </TitleWrapper>
    </Box>
  );
};
